import '@/plugins/axios'
import { getBaseUrl, getParameter } from '@/utils/endpoint'

export function getData(params = {}) {
  const new_params = { ...getParameter(), ...params }
  return window.axios.get(getBaseUrl() + '/discount', { params: new_params })
}

export function getDataValidate(data, params = {}) {
  const new_params = { ...getParameter(), ...params }
  return window.axios.post(getBaseUrl() + '/discount', data, { params: new_params })
}

export function getDataDetail(id, params = {}) {
  const new_params = { ...getParameter(), ...params }
  return window.axios.get(getBaseUrl() + '/discount/' + id, { params: new_params })
}

export function getDataDetailValidate(id, data, params = {}) {
  const new_params = { ...getParameter(), ...params }
  return window.axios.post(getBaseUrl() + '/discount/' + id, data, { params: new_params })
}

export function hitDiscount(data, params = {}) {
  const new_params = { ...getParameter(), ...params }
  return window.axios.post(getBaseUrl() + '/discount/hit', data, { params: new_params })
}

export function hitPotentialDiscount(data, params = {}) {
  const new_params = { ...getParameter(), ...params }
  return window.axios.post(getBaseUrl() + '/discount/potential', data, { params: new_params })
}
